import { render, staticRenderFns } from "./addgameType.vue?vue&type=template&id=ad3c6bd8&"
import script from "./addgameType.vue?vue&type=script&lang=js&"
export * from "./addgameType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3c6bd8')) {
      api.createRecord('ad3c6bd8', component.options)
    } else {
      api.reload('ad3c6bd8', component.options)
    }
    module.hot.accept("./addgameType.vue?vue&type=template&id=ad3c6bd8&", function () {
      api.rerender('ad3c6bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addgameType.vue"
export default component.exports